var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1146,
    height: 1478,
    viewBox: "0 0 1146 1478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956.754 267.416L419.297 588.674V1428.26",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.742 166.458L240.285 487.716L240.285 1086.7",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.787 713.504L1100.52 401.053",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0547 394.451L572.792 82",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.787 936.452L1100.52 624.001",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.787 1153.83L1100.52 841.374",
    stroke: "white",
    strokeWidth: 89.5069,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.1742,
    cy: 598.609,
    r: 48.5941,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.1742,
    cy: 792.936,
    r: 48.5941,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.1742,
    cy: 987.259,
    r: 48.5941,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo_big.0c4da3c58d0f99fa7ac847ed861790ca.svg";
export { ForwardRef as ReactComponent };